import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Chip
} from '@mui/material';

export default function NewNoteDialog({ open, onClose, project, connectionIndex, currentStepId, defaultName = '', onAddNote }) {
  const [name, setName] = useState('');
  const [content, setContent] = useState('');
  const [stepIds, setStepIds] = useState([]);
  const [newStepId, setNewStepId] = useState('');

  // Reset form and set current step when dialog opens
  useEffect(() => {
    if (open) {
      setName(defaultName);
      setContent('');
      setStepIds(currentStepId ? [currentStepId] : []);
      setNewStepId('');
    }
  }, [open, currentStepId, defaultName]);

  const handleAddStepId = () => {
    if (newStepId && !stepIds.includes(newStepId)) {
      setStepIds([...stepIds, newStepId]);
      setNewStepId('');
    }
  };

  const handleSave = async () => {
    if (!project || connectionIndex === undefined || !name.trim()) return;

    await onAddNote(name.trim(), content.trim(), stepIds);

    // Reset form and close dialog
    setName('');
    setContent('');
    setStepIds(currentStepId ? [currentStepId] : []);
    onClose();
  };

  const handleClose = () => {
    setName('');
    setContent('');
    setStepIds(currentStepId ? [currentStepId] : []);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Note</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Note Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mb: 2, mt: 1 }}
        />
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Note Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Associated Steps
          </Typography>
          {currentStepId && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Current Step: {currentStepId}
            </Typography>
          )}
          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
            <TextField
              label="Step ID"
              value={newStepId}
              onChange={(e) => setNewStepId(e.target.value)}
              size="small"
            />
            <Button
              variant="contained"
              onClick={handleAddStepId}
              disabled={!newStepId.trim()}
            >
              Add Step
            </Button>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {stepIds.map((stepId) => (
              <Chip
                key={stepId}
                label={`Step ${stepId}`}
                onDelete={() => setStepIds((ids) => ids.filter((id) => id !== stepId))}
                color={stepId === currentStepId ? "primary" : "default"}
              />
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={handleSave} 
          variant="contained"
          disabled={!name.trim()}
        >
          Save Note
        </Button>
      </DialogActions>
    </Dialog>
  );
} 